import React, { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import useDeepCompareEffect from 'use-deep-compare-effect';

import { useDebounce } from '../../../hooks';

export const VpAutoSave = memo(({ defaultValues, onSubmit }) => {
  const { handleSubmit, formState } = useFormContext();
  const onChangeDebounce = useDebounce(() => {
    handleSubmit(onSubmit)();
  }, 1000);

  const watchedData = useWatch({
    defaultValue: defaultValues
  });

  useDeepCompareEffect(() => {
    if (formState.isDirty) {
      onChangeDebounce();
    }
  }, [watchedData]);

  return <div />;
});

VpAutoSave.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func
};

VpAutoSave.displayName = 'VpAutoSave';

export default VpAutoSave;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpAutoSave/VpAutoSave.jsx